import { SqlRbacAction } from "services/rbac/action";

export const engineActions = [
  SqlRbacAction.ENGINE_CREATE,
  SqlRbacAction.USAGE,
  SqlRbacAction.OPERATE,
  SqlRbacAction.MODIFY,

  SqlRbacAction.ENGINE_USAGE_ANY,
  SqlRbacAction.ENGINE_MODIFY_ANY,
  SqlRbacAction.ENGINE_OPERATE_ANY,
];

export const databaseActions = [
  SqlRbacAction.DATABASE_CREATE,
  SqlRbacAction.MODIFY,
  SqlRbacAction.USAGE,

  SqlRbacAction.DATABASE_USAGE_ANY,
  SqlRbacAction.DATABASE_MODIFY_ANY,
];
